/**
 * Kom ihåg vad röstinmatningen skrev i chattfältet, så att `question_asked`
 * kan märkas med hur frågan kom till (`input_method`):
 *
 * - `voice`        skickad exakt som den transkriberades
 * - `voice_edited` transkriberad och sedan ändrad (minst hälften av de
 *                  talade orden finns kvar)
 * - `text`         allt annat, även när ett transkript raderades och frågan
 *                  skrevs om från början
 *
 * `voice_edited`-andelen är en kvalitetssignal: rättar läkarna ofta texten
 * hör modellen fel. Klientsidigt och modulglobalt (en chatt per sida).
 * Ingen text lämnar modulen; bara etiketten används för analys.
 */

export type InputMethod = 'voice' | 'voice_edited' | 'text'

let lastVoiceText: string | null = null

const normalize = (s: string) => s.replace(/\s+/g, ' ').trim()
const words = (s: string) =>
	normalize(s)
		.toLowerCase()
		.split(' ')
		.map(w => w.replace(/[^\p{L}\p{N}-]/gu, ''))
		.filter(Boolean)

/** Anropas med HELA fältets text efter att transkriptet lagts in. */
export function rememberVoiceText(composerText: string) {
	lastVoiceText = normalize(composerText)
}

/** Avgör och glömmer — en etikett per skickad fråga. */
export function takeInputMethod(sentText: string): InputMethod {
	const voice = lastVoiceText
	lastVoiceText = null
	if (!voice) return 'text'
	if (normalize(sentText) === voice) return 'voice'
	const sent = new Set(words(sentText))
	const spoken = words(voice)
	const kept = spoken.filter(w => sent.has(w)).length
	return spoken.length > 0 && kept / spoken.length >= 0.5
		? 'voice_edited'
		: 'text'
}
